import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=3c639652&scoped=true"
import script from "./Error.vue?vue&type=script&setup=true&lang=ts"
export * from "./Error.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Error.vue?vue&type=style&index=0&id=3c639652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c639652",
  null
  
)

export default component.exports